import { OnboardingData } from './onboarding-data.model';

export const initialOnboardingData: OnboardingData = {
  applicationId: null,
  email: '',
  status: 'draft',
  currentStepKey: 'contact_details',
  rejectionReason: null,
  additionalNotes: '',
  contactDetails: { 
    legalEntityName: '',
    fleetName: '', 
    fleetPhone: '',
    address: { line1: '', line2: '', city: '', county: '', postcode: '', latitude: null, longitude: null }, 
    contactName: '', 
    contactEmail: '', 
    contactPhone: '',
    useLegalNameAsFleetName: true,
  },
  fleetOps: { fleetSize: '', serviceLevel: '', dispatchSystem: '', dispatchSystemOther: '', workSplit: { bookingType: { prebook: 50, asap: 50 }, paymentType: { account: 50, card: 50, cash: 0 } }, },
  documents: { EmployersLiabilityInsurance: null, PublicLiabilityInsurance: null, OperatorsLicence: null },
  confirmations: {
    terms: false,
    termsAcceptedAt: null,
    dataSharing: false,
    dataSharingAcceptedAt: null,
    codeOfConduct: false,
    codeOfConductAcceptedAt: null,
    isAuthorised: false,
    signedVersions: null,
  }
};